import axios from 'axios'

const getBalanceSumary = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/financial/balance/sumary`)
  return data
}

const getBalanceByDate = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/financial/balance/from`, {
    params: {
      iniDate,
      endDate
    }
  })
  return data
}

const getFutureYearBalances = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/financial/balance/yearly`)
  return data
}

// Get all financial data for business
const getAll = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/financial/business/${iniDate}/${endDate}`)
  return data
}

export {
  getBalanceSumary,
  getBalanceByDate,
  getFutureYearBalances,
  getAll
}
